import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { CARD_STATUS_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { CARD_STATUS_REPORT } from "../interfaces/dashboard";

export default function CardStatus() {
    const cardStatusReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.CARD_STATUS_REPORT;

    const [cardStatusReportTableData, setCardStatusReportTableData] = useState<CARD_STATUS_REPORT[]>([]);

    useEffect(() => {
        setCardStatusReportTableData(CARD_STATUS_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="CARD_STATUS"
        tableColumns={cardStatusReportTableColumns}
        tableData={cardStatusReportTableData} />
    );
}